import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { toSignal } from '@angular/core/rxjs-interop';
import { PageLoadingService } from '@app/core/services/page-loading/page-loading.service';
import { ProgressBar } from 'primeng/progressbar';
import { Toast } from 'primeng/toast';
import { ToastKey } from '@app/core/enums/toast-key.enum';
import { ToastContentComponent } from '@app/shared/components/toast-content/toast-content.component';
import { DOCUMENT } from '@angular/common';
import { environment } from '@environment';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';

@Component({
  selector: 'gc-app',
  imports: [RouterOutlet, ProgressBar, Toast, ToastContentComponent, SpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly document: Document = inject(DOCUMENT);
  private readonly pageLoadingService: PageLoadingService = inject(PageLoadingService);
  private titleService: Title = inject(Title);

  public isNavigationPending;

  protected readonly ToastKey = ToastKey;

  constructor() {
    this.hideBootstrapLoader();

    this.isNavigationPending = toSignal(this.pageLoadingService.isNavigationPending());

    this.titleService.setTitle(environment.title);
  }

  public hideBootstrapLoader() {
    const loader = this.document.getElementById('gc-app-loader');
    if (loader) loader.style.display = 'none';
  }
}
